<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<mat-dialog-content class="mat-typography">
    <mat-form-field appearance="fill">
        <mat-label>Event Name</mat-label>
        <input matInput placeholder="Enter Event Name" [(ngModel)]="show.custom_name" required>
    </mat-form-field>
    <mat-form-field appearance="fill" [class]="!env.showBrands ? 'hidden' : ''">
        <mat-label>Brand</mat-label>
        <mat-select disableRipple [(ngModel)]="show.brand_id">
            <mat-option [value]="0">Select Brand</mat-option>
            <mat-option *ngFor="let brand of brands" [value]="brand.id">{{ brand.name }}</mat-option>
        </mat-select>
    </mat-form-field>
    <p class="text-align">Brands allow you to customize the look and feel of the experience after the show code is
        entered. This
        includes a header and footer image, background and colors, and more... To learn more and to create / edit
        brands, goto My Brands in the menu.</p>
    <mat-card appearance="outlined" class="custom-card" style="margin-bottom: 20px;">
        <mat-card-header>
            <mat-card-title>Venue Location</mat-card-title>
            <p>This is the address of the physical venue where your show will take place.</p>
        </mat-card-header>
        <mat-card-content>
            <!-- <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar> -->


            <mat-form-field appearance="fill" class="single-field">
                <mat-label>Address Line 1</mat-label>
                <textarea matInput [(ngModel)]="show.address1"></textarea>
            </mat-form-field>

            <mat-form-field appearance="fill" class="single-field">
                <mat-label>Address Line 2</mat-label>
                <textarea matInput [(ngModel)]="show.address2"></textarea>
            </mat-form-field>

            <mat-form-field appearance="fill" class="single-field">
                <mat-label>City</mat-label>
                <input matInput [(ngModel)]="show.city">
            </mat-form-field>

            <mat-form-field appearance="fill" class="single-field">
                <mat-label>State</mat-label>
                <input matInput [(ngModel)]="show.state">
            </mat-form-field>

            <mat-form-field appearance="fill" class="single-field">
                <mat-label>Country</mat-label>
                <input matInput [(ngModel)]="show.country">
            </mat-form-field>

            <mat-form-field appearance="fill" class="single-field">
                <mat-label>Latitude, Longitude</mat-label>
                <textarea matInput (keypress)="onLatLngChange($event)" placeholder="24.8607, 67.0011"
                    [(ngModel)]="show.coordinates"></textarea>
            </mat-form-field>
            <p class="text-align">This value will populate automatically when saving the address to the show.</p>
            <p class="text-align error" *ngIf="error_massage">{{error_massage}}</p>
        </mat-card-content>
    </mat-card>
    <div class="show-date" appearance="fill">
        <h4 class="text">Show Date</h4>
        <mat-form-field appearance="fill">
            <mat-label>Choose Show date</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="show.show_date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <!-- <mat-form-field>
        <input matInput type="time" #timeInput (blur)="valdiateTime()" placeholder="Choose Show Time" [(ngModel)]="show.show_time">
    </mat-form-field> -->
    <div class="show-time" appearance="fill">
        <h4 class="text">Show Time</h4>
        <mat-form-field class="half-width">
            <mat-label>Hours</mat-label>
            <mat-select [(ngModel)]="show_hours">
                <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="half-width">
            <mat-label>Minutes</mat-label>
            <mat-select [(ngModel)]="show_minutes">
                <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="time-zone" appearance="fill">
        <h4 class="text">Timezone</h4>
        <mat-form-field appearance="fill" >
            <mat-label>Timezone</mat-label>
            <mat-select disableRipple [(ngModel)]="show.show_timezone">
                <mat-option [value]="">Select Timezone</mat-option>
                <mat-option *ngFor="let timezone of timezones" [value]="timezone.diff" >
                    <span class="timezone-option" [title]="timezone.diff">
                        {{ timezone.name + " (UTC " + timezone.diff + ")" }}
                    </span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="!show.show_timezone" class="change-timezone">
        <a (click)="setTimezone()">Change to {{ show.user_timezone }}</a>
    </div>

    <!-- <mat-form-field appearance="fill" class="single-field">
        <mat-label>Nearby Shows Extended Days</mat-label>
        <input matInput placeholder="Enter number of days" [(ngModel)]="show.no_of_days">
    </mat-form-field>
    <p class="text-align">Enter the number of days your show will last from the set show date. This will
        allow the show to appear as a nearby show in the app during this time window</p> -->

        <div>
            <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="includeNearbyShows">Include this show in Nearby Shows?
        </mat-checkbox>
        </div>
        
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Nearby Shows Extended Days</mat-label>
        <input matInput placeholder="Enter number of days" [(ngModel)]="show.no_of_days" name="no_of_days"
            #noOfDays="ngModel" pattern="^[0-9]+$" (ngModelChange)="validateNoOfDays()" />
    </mat-form-field>
    <mat-error *ngIf="errorMessage" class="text-align">{{ errorMessage }}</mat-error>

    <p class="text-align">
        Enter the number of days your show will last from the set show date.
        This will allow the show to appear as a nearby show in the app during this time window.
    </p>

    <mat-form-field appearance="fill">
        <mat-label>Show Date and Time Override Text <span
                *ngIf="show && show.datetime_text && show.datetime_text.length > 0">({{ show.datetime_text.length }} /
                45 characters)</span></mat-label>
        <input matInput placeholder="Enter Show Date and Time Override Text" [(ngModel)]="show.datetime_text"
            maxlength="45">
    </mat-form-field>
    <p class="text-align">Replace the show date and time on the app and web page player with this text. By populating
        this field, you won’t affect any change to functionality associated to show’s official show date and time.
        (Maximum 45 Characters)</p>
    <p *ngIf="isTune2" class="text-align">The show date, time, and timezone fields are only used for Static shows, they
        are not used for Synchronized shows.</p>
    <h3 *ngIf="isTune2" class="custom-heading">Static Show</h3>
    <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.start_automatically"
            (change)="onAutoStartChange($event)">Start show automatically at this time
        </mat-checkbox>
        <small style="display: block; margin-left: 38px;">The show will start automatically at the above specified date
            and time within selected time zone. We suggest you test this functionality based on your current time zone
            as a dry run to ensure everything is set correctly.</small><br>
    </div>
    <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.start_from_beginning"
            (change)="onStartBeginningChange($event)">Play audio when show is first opened</mat-checkbox>
        <small style="display: block; margin-left: 38px;">The show will begin to play audio immediately when the user
            chooses to listen to the show. This feature ignores any operator action to play, pause or stop the show and
            any show time set above. It simply plays the audio when the Listen to Show button is pressed.</small><br>
    </div>
    <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.looping">Loop Soundtrack
        </mat-checkbox>
        <small style="display: block; margin-left: 38px;">The soundtrack will continue to loop (play back to back) for
            the listener. It is recommended to use this feature in combination with the start automatically
            feature.</small><br>
    </div>
    <!-- <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.sequence" (change)="sequenceOption($event)">Sequence</mat-checkbox>
    </div> -->
    <div class="file-upload" style="margin-bottom: 20px;">
        <button mat-raised-button
            [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
            class="instruction-button" (click)="uploadAudio()">
            Browse and select MP3 file...
        </button>
    </div>

    <div *ngIf="isTune2" style="margin-bottom: 20px;">
        <h3 class="custom-heading">Synchronized Show</h3>
        <p class="text-align">If you are performing a synchronized / sequenced lights show using xLights (xSchedule),
            Falcon Player (FPP), and Light-O-Rama (LOR), you don't need to upload a soundtrack as this is done
            automatically using the Tune2 Sync application after you create the show from here.</p>
        <button mat-raised-button
            [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
            class="instruction-button" (click)="openTune2Sync()">
            Tune2 Sync Installation Instructions
        </button>
    </div>

    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Description <span *ngIf="show && show.description && show.description.length > 0">({{
                show.description.length }} / 270 characters)</span></mat-label>
        <textarea matInput [(ngModel)]="show.description" maxlength="270" rows="10"></textarea>
    </mat-form-field>
    <p class="text-align errors" *ngIf="show && show.description && show.description.length > 270">Description will be
        truncated to 270 characters when saved.</p>
    <p class="text-align">(Maximum 270 Characters)</p>

    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Website URL (make sure to include http:// or https://)</mat-label>
        <input matInput [(ngModel)]="show.website_url">
    </mat-form-field>
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Extra Button Label (up to 15 characters)</mat-label>
        <input type="text" matInput [(ngModel)]="show.extra_button_text" maxlength="15">
    </mat-form-field>

    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Extra Button URL (make sure to include http:// or https://)</mat-label>
        <input type="text" matInput [(ngModel)]="show.extra_button_url">
    </mat-form-field>
    <div class="editor-field">
        <label>Terms & Conditions</label>
        <angular-editor [(ngModel)]="show.terms" [config]="editorConfig"></angular-editor>
    </div>
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>SMPTE Offset (s)</mat-label>
        <input type="number" matInput [(ngModel)]="show.smpte_offset"
            [disabled]="show.audio_file_info && show.audio_file_info.timecode_channel=='none'">
    </mat-form-field>
    <p class="smpt-offset-description" *ngIf="show.audio_file_info && show.audio_file_info.timecode_channel=='none'">
        This field is only supported for shows with SMPTE time code.</p>
    <p class="smpt-offset-description" *ngIf="show.audio_file_info && show.audio_file_info.timecode_channel=='right'">
        This will add the entered number of seconds (up to 300) as silence to the beginning of the operator played
        soundtrack. This same number of seconds will delay the playback on the audience played soundtrack. By having
        this offset, it allows the operator to have a pre-roll of SMPTE before the show starts.</p>


    <!--<mat-form-field appearance="fill">
        <mat-label>Video Before Show</mat-label>
        <input matInput [(ngModel)]="show.video_before_show">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Video After Show</mat-label>
        <input matInput [(ngModel)]="show.video_after_show">
    </mat-form-field>-->
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancel-popup" mat-stroked-button (click)="close()">Cancel</button>
    <button class="popup-save" mat-flat-button
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" (click)="save()"
        cdkFocusInitial [disabled]="processing">
        <mat-icon *ngIf="processing">
            <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
        </mat-icon>
        Save
    </button>
</mat-dialog-actions>